export const HEADERS = [
    { key: 'idIssue', value: 'Id', sticky: 'left', minWidth: 0 },
    { key: 'summary', value: 'Résumé', minWidth: 0 },
    { key: 'project', value: 'Projet', minWidth: 0 },
    { key: 'reporter', value: 'Rapporteur', minWidth: 0 },
    { key: 'handler', value: 'Affecté à', minWidth: 0 },
    { key: 'submittedAt', value: 'Date de soumission', minWidth: 0 },
    { key: 'product', value: 'Produit', minWidth: 0 },
    { key: 'balises', value: 'Fonctionnalité (balises)', minWidth: 0 },
    { key: 'changeLog', value: 'Changelog', minWidth: 0 },
]